import React, { Component, useEffect, useMemo, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import config from "../../config.json";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Form from "../../comman/form";
import AddWorkingHrs from "./AddWorkingHrs";
import {
  getAllMonths,
  getAllYears,
  getDateOnly,
  getTotalHours,
  sanitizeEvent,
  sanitizeEventList,
  toLocalDate,
} from "../../services/appService";
import { useDispatch, useSelector } from "react-redux";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import { getCurrentUser } from "../../app/store/auth";
import { addNewTmLog, getTmLogAddedStatus } from "../../app/store/timeLog";

const AddNewTimeLog = (props) => {
  const {
    showHide: tmShowHide,
    handleShowHide,
    viewType,
    selectedObj,
    allTimeLogs,
    candidateObj,
    timeLogInvoices,
    projectStartDate,
  } = props;

  const localizer = momentLocalizer(moment);

  const years = getAllYears();
  const months = getAllMonths();

  const [selectedDate, setSelectedDate] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [allEvents, setAllEvents] = useState([]);
  const [docType, setDocType] = useState("monthly");
  const [monthlyHrs, setMonthlyHrs] = useState("");
  const [chkMonthlyHrs, setChkMonthlyHrs] = useState("");
  const [monthlyDays, setMonthlyDays] = useState("");
  const [documents, setDocuments] = useState([]);
  const [wrkHrShowHide, setWrkHrShowHide] = useState(false);
  const [dtObj, setDtObj] = useState(null);
  const [currentWfTask, setCurrentWfTask] = useState(null);
  const [saveTmWithDocs, setSaveTmWithDocs] = useState(false);
  const [saveBtnProccess, setSaveBtnProccess] = useState(false);
  const [prjStartYear, setPrjStartYear] = useState(0);
  const [prjStartMonth, setPrjStartMonth] = useState(0);
  const [prjStartMonthDay, setPrjStartMonthDay] = useState(0);

  const tmLogAddedStatusSelector = useSelector(getTmLogAddedStatus);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    if (allTimeLogs.length > 0) {
      let events = [];
      allTimeLogs.forEach((t) => {
        if (!t.workingHrs) return;

        const wt = JSON.parse(t.workingHrs);

        wt.forEach((w) => {
          if (w.type === "m") return;
          const dt = toLocalDate(w.start);
          events.push({
            start: dt,
            end: dt,
            title: w.title,
          });
        });
      });

      setAllEvents(events);
    }
  }, [allTimeLogs]);

  useEffect(() => {
    if (selectedObj) {
      setSelectedYear(selectedObj.year);
      setSelectedMonth(selectedObj.month);
      setDocType(selectedObj.docUploadType);
      setDocuments([]);
      const dt = new Date(selectedObj.year, selectedObj.month - 1, 1);
      setSelectedDate(dt);
      // if(candidateObj?.duration){
      //   const dur = new Date(candidateObj.duration?.startDate);
      //   console.log(dur, "dur")
      //   setPrjStartYear(dur.getFullYear());
      //   setPrjStartMonth(dur.getMonth() + 1);
      // }

      if (selectedObj.workingHrs) {
        // console.log(selectedObj, "selectedObj")
        try {
          const hrsArray = JSON.parse(selectedObj.workingHrs);
          if (hrsArray.length > 0) {
            const { title, days, type } = hrsArray[0];
            if (type) {
              if (title || days) {
                setChkMonthlyHrs("monthly");
                setMonthlyHrs(title);
                setMonthlyDays(days);
              }
            }
          }
        } catch (err) {
          console.error("Failed to parse workingHrs:", err);
        }
      }
    } else {
      const dt = new Date();
      const year = dt.getFullYear();
      const month = dt.getMonth();
      setSelectedYear(year);
      setSelectedMonth(month + 1);
      setSelectedDate(dt);
      setChkMonthlyHrs("");
      setDocType("monthly");
      setMonthlyHrs("");
      setMonthlyDays("");
      setDocuments([]);
    }

    if (projectStartDate) {
      const dur = new Date(projectStartDate);
      console.log(dur, "dur");
      setPrjStartYear(dur.getFullYear());
      setPrjStartMonth(dur.getMonth() + 1);
      setPrjStartMonthDay(dur.getDate());
    } else {
      setPrjStartYear(0);
      setPrjStartMonth(0);
    }
  }, [selectedObj]);

  const handleOnChange = ({ currentTarget }) => {
    const id = currentTarget.id.split("_")[1];
    const name = currentTarget.id.split("_")[0];
    const { timeLogs } = this.state;
    let obj = timeLogs.filter((x) => x.id === parseInt(id))[0];
    const index = timeLogs.findIndex((x) => x.id === parseInt(id));
    obj[name] = currentTarget.value;
    timeLogs[index] = obj;
    //this.setState({ timeLogs });
  };

  const doSubmit = (type) => {
    setSaveBtnProccess(true);
    if (type === "reset") setSelectedYear(null);
    const selectedTimeLog = allTimeLogs.filter(
      (x) =>
        x.year === parseInt(selectedYear) &&
        x.month === parseInt(selectedMonth),
    );
    if (selectedTimeLog.length > 0) {
      checkInvoiceStatus(selectedTimeLog);
    } else {
      saveTmLogs();
    }
  };

  const checkInvoiceStatus = (selectedTimeLog) => {
    const tmLog = selectedTimeLog[0];
    const invType = ["recruiter", "subcontractor"];
    const checkApproved = timeLogInvoices?.filter(
      (x) =>
        x.timeLogId === tmLog.id &&
        // x.invoiceType === invType &&
        invType.includes(x.invoiceType) &&
        x.status === true,
    );
    if (checkApproved.length > 0) {
      getAlert("", "Timelog is already Approved", "error");
    } else {
      saveTmLogs();
    }
  };

  const saveTmLogs = async () => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you have entered the correct hours for the Week/Month?",
      "warning",
    );
    if (result.isConfirmed) {
      if (documents.length > 0) saveTmDocs();
      else saveTimeLogs(0);
    }
  };

  const saveTmDocs = async () => {
    const frmData = new FormData();
    frmData.append("message", "Time Sheet");
    frmData.append("workflowTask", JSON.stringify(currentWfTask));
    frmData.append("userId", currentUser.id);
    frmData.append("docType", docType + "_time_sheet");
    documents.map((file, key) =>
      frmData.append("files[" + key + "]", file.file),
    );
    //dispatch(uploadAppDocuments(frmData));
    setSaveTmWithDocs(true);
  };

  const saveTimeLogs = (docId) => {
    // Normalize mixed Date/string calendar events before filtering/saving.
    const normalizedEvents = sanitizeEventList(allEvents);

    // Filter events that belong to the selected month/year
    const filterEvents = normalizedEvents.filter((e) => {
      const [year, month] = getDateOnly(e.start).split("-").map(Number);

      return year === Number(selectedYear) && month === Number(selectedMonth);
    });

    const tmObj = {};

    // Handle MONTHLY HOURS mode
    if (chkMonthlyHrs === "monthly" && Number(monthlyHrs) > 0) {
      const selMonth =
        Number(selectedMonth) < 10
          ? "0" + Number(selectedMonth)
          : selectedMonth;

      const selDays = monthlyDays || 0;
      const formattedMonthlyHrs = monthlyHrs.toString().trim();

      const newEvents = [
        {
          start: `${selectedYear}-${selMonth}-01`,
          end: `${selectedYear}-${selMonth}-02`,
          title: formattedMonthlyHrs,
          type: "m",
          days: selDays,
        },
      ];

      tmObj["workingHrs"] = JSON.stringify(newEvents);
    }
    // DAILY MODE
    else {
      tmObj["workingHrs"] =
        filterEvents.length > 0 ? JSON.stringify(filterEvents) : null;
    }

    // Additional fields
    tmObj["candidateId"] = candidateObj.performerid;
    tmObj["subcontractorId"] = candidateObj.validId;
    tmObj["docId"] = docId;
    tmObj["docUploadType"] = docType;
    tmObj["year"] = Number(selectedYear);
    tmObj["month"] = Number(selectedMonth);

    if (selectedObj?.id > 0) {
      tmObj["id"] = selectedObj.id;
    }

    dispatch(addNewTmLog(tmObj));
  };

  useEffect(() => {
    if (tmLogAddedStatusSelector) {
      getAlert("", "Timelog Updated Successfully", "success");
      setSaveBtnProccess(false);
      handleShowHide("save");
    }
  }, [tmLogAddedStatusSelector]);

  const handleSelect = (wrkHr) => {
    if (!dtObj) return;

    const { start, end } = dtObj;

    // Always convert selected date into YYYY-MM-DD
    const selectedDate = getDateOnly(start);

    // Clean list (remove any events that have times)
    let updatedEvents = [...allEvents].map((ev) => sanitizeEvent(ev));

    // Find all events on this day
    const sameDayEvents = updatedEvents.filter((x) => x.start === selectedDate);

    if (sameDayEvents.length > 0) {
      // Take first one to update
      const target = sameDayEvents[0];
      const targetIndex = updatedEvents.indexOf(target);

      // Remove duplicates on same date (if any)
      if (sameDayEvents.length > 1) {
        sameDayEvents.slice(1).forEach((dupEv) => {
          const dupIndex = updatedEvents.indexOf(dupEv);
          if (dupIndex !== -1) updatedEvents.splice(dupIndex, 1);
        });
      }

      // Update the selected event
      updatedEvents[targetIndex] = {
        ...updatedEvents[targetIndex],
        title: wrkHr,
      };
    } else {
      // Add new event (date-only)
      updatedEvents.push({
        start: selectedDate,
        end: selectedDate,
        title: wrkHr,
      });
    }

    setAllEvents(updatedEvents);
    setWrkHrShowHide(false);
    setDtObj(null);
  };

  const handleeEditSelect = (wrkHr) => {
    if (!dtObj) return;

    // Always sanitize date fields from dtObj
    const targetStart = getDateOnly(dtObj.start);
    const targetEnd = getDateOnly(dtObj.end);
    const targetTitle = dtObj.title;

    // Always sanitize event list to keep everything date-only
    const events = [...allEvents].map((ev) => sanitizeEvent(ev));

    // Find correct event (safe for USA/India timezones)
    const index = events.findIndex((x) => {
      return (
        x.start === targetStart &&
        x.end === targetEnd &&
        x.title === targetTitle
      );
    });

    if (index === -1) return; // No match found

    // Update the found event immutably
    const updatedEvents = [...events];
    updatedEvents[index] = {
      ...updatedEvents[index],
      title: wrkHr,
    };

    setAllEvents(updatedEvents);
  };

  const handleYearChange = ({ currentTarget }) => {
    setSelectedYear(currentTarget.value);
    const newDt = new Date(currentTarget.value, selectedMonth - 1, 1);
    setSelectedDate(newDt);
  };

  const handleMonthChange = ({ currentTarget }) => {
    if (prjStartYear === selectedYear && currentTarget.value < prjStartMonth) {
      getAlert(
        "",
        `Month should be greater than or equal to ${months.find((x) => x.id === prjStartMonth).name}`,
        "error",
      );
      return;
    }
    setSelectedMonth(currentTarget.value);
    const newDt = new Date(selectedYear, currentTarget.value - 1, 1);
    setSelectedDate(newDt);
  };

  const handleDateChanged = (date) => {
    // Extract safe local date (prevents timezone shift)
    const getLocalDateParts = (d) => {
      const dt = new Date(d);
      return {
        year: dt.getFullYear(),
        month: dt.getMonth(), // 0-based
        day: dt.getDate(),
        full: dt,
      };
    };

    const { year, month, full } = getLocalDateParts(date);

    const cyear = new Date().getFullYear();
    const cmonth = new Date().getMonth();

    const findYear = years.filter((x) => x.name === year);

    if (
      (year === cyear && month <= cmonth && findYear.length > 0) ||
      (year < cyear && findYear.length > 0)
    ) {
      setSelectedYear(year);
      setSelectedMonth(month + 1); // convert 0-based → 1-based
      setSelectedDate(full); // safe Date object
    }
  };

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (let file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleWrkHrShowHide = (obj) => {
    if (!obj) {
      setWrkHrShowHide(false);
      setDtObj(null);
      return;
    }

    const dt = new Date(obj.start); // Date user clicked

    // If this is a slot click (outside the green card) but an event already exists for this date,
    // use the event object instead so the logged hours are populated for editing.
    if (obj && !obj.title) {
      const clickedDateStr = getDateOnly(dt);
      const matchedEvents = allEvents.filter(
        (ev) => getDateOnly(ev.start) === clickedDateStr
      );
      if (matchedEvents.length > 0) {
        obj = matchedEvents[0];
      }
    }
    const now = new Date();

    // Compare only the date (ignore time)
    const currentDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
    );
    const targetDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());

    // 🔢 Convert all year/month/day values to numbers
    const selectedYearNum = parseInt(selectedYear, 10);
    const selectedMonthNum = parseInt(selectedMonth, 10);
    const prjStartYearNum = parseInt(prjStartYear, 10);
    const prjStartMonthNum = parseInt(prjStartMonth, 10);
    const prjStartMonthDayNum = parseInt(prjStartMonthDay, 10);

    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    if (dt.getMonth() + 1 !== selectedMonthNum) return;

    const showError = (msg) => getAlert("", msg, "error");

    // --- 1️⃣ Block: Before project start ---
    if (
      selectedYearNum < prjStartYearNum ||
      (selectedYearNum === prjStartYearNum &&
        selectedMonthNum < prjStartMonthNum)
    ) {
      return showError(
        "You cannot add working hours for months before the project start date.",
      );
    }

    // --- 🆕 Additional Day Check for Project Start Month ---
    if (
      selectedYearNum === prjStartYearNum &&
      selectedMonthNum === prjStartMonthNum
    ) {
      if (dt.getDate() < prjStartMonthDayNum) {
        return showError(
          `You cannot add working hours before the project start date (${prjStartMonthDayNum}/${prjStartMonthNum}/${prjStartYearNum}).`,
        );
      }
    }

    // --- 2️⃣ Block: Future months ---
    if (
      selectedYearNum > currentYear ||
      (selectedYearNum === currentYear && selectedMonthNum > currentMonth)
    ) {
      return showError("You cannot add working hours for future months.");
    }

    // --- 3️⃣ Current month handling ---
    if (selectedYearNum === currentYear && selectedMonthNum === currentMonth) {
      if (targetDate > currentDate) {
        return showError("You cannot add working hours for future dates.");
      }

      // ✅ Allow today and past dates in current month
      setWrkHrShowHide((prev) => !prev);
      setDtObj(obj);
      return;
    }

    // --- 4️⃣ Past months (after project start, before current month) ---
    if (
      (selectedYearNum > prjStartYearNum ||
        (selectedYearNum === prjStartYearNum &&
          selectedMonthNum >= prjStartMonthNum)) &&
      (selectedYearNum < currentYear ||
        (selectedYearNum === currentYear && selectedMonthNum < currentMonth))
    ) {
      // ✅ Allow all days in past months (after start)
      setWrkHrShowHide((prev) => !prev);
      setDtObj(obj);
      return;
    }

    // --- 5️⃣ Fallback ---
    showError("Unable to add working hours for this date.");
  };

  const handleChkMonthly = ({ target }) => {
    if (target.checked) {
      setChkMonthlyHrs("monthly");
    } else {
      setChkMonthlyHrs("");
    }
  };

  const handleReset = async () => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Reset the entered hours for the week(s)/month?",
      "warning",
    );

    if (!result.isConfirmed) return;

    // Restore header fields
    if (selectedObj?.id > 0) {
      setSelectedYear(selectedObj.year);
      setSelectedMonth(selectedObj.month);
      setDocType(selectedObj.docUploadType);
      setDocuments([]);

      const dt = new Date(selectedObj.year, selectedObj.month - 1, 1);
      setSelectedDate(dt);
    } else {
      const dt = new Date();
      setSelectedYear(dt.getFullYear());
      setSelectedMonth(dt.getMonth() + 1);
      setSelectedDate(dt);

      setChkMonthlyHrs("");
      setDocType("monthly");
      setMonthlyHrs("");
      setMonthlyDays("");
      setDocuments([]);
    }

    // Build event list safely (with dateUtils)
    const events = [];

    allTimeLogs.forEach((t) => {
      if (!t.workingHrs) return;

      const wt = JSON.parse(t.workingHrs);

      wt.forEach((w) => {
        // Convert any format → YYYY-MM-DD safely
        const cleanEvent = sanitizeEvent({
          start: w.start,
          end: w.start,
          title: w.title,
        });

        events.push(cleanEvent);
      });
    });

    setAllEvents(events);
    getAlert("", "Reset Successfully", "success");
  };

  const loggedHoursByDate = useMemo(() => {
    return allEvents.reduce((acc, event) => {
      const dateKey = getDateOnly(event?.start);
      if (dateKey) acc[dateKey] = event?.title;
      return acc;
    }, {});
  }, [allEvents]);

  const isBlockedCalendarDate = (date) => {
    const calendarDate = new Date(date);
    const today = new Date();
    const targetDate = new Date(
      calendarDate.getFullYear(),
      calendarDate.getMonth(),
      calendarDate.getDate(),
    );
    const currentDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );
    const selectedYearNum = parseInt(selectedYear, 10);
    const selectedMonthNum = parseInt(selectedMonth, 10);
    const prjStartYearNum = parseInt(prjStartYear, 10);
    const prjStartMonthNum = parseInt(prjStartMonth, 10);
    const prjStartMonthDayNum = parseInt(prjStartMonthDay, 10);

    if (calendarDate.getMonth() + 1 !== selectedMonthNum) return true;
    if (targetDate > currentDate) return true;
    if (!prjStartYearNum || !prjStartMonthNum) return false;
    if (selectedYearNum < prjStartYearNum) return true;
    if (
      selectedYearNum === prjStartYearNum &&
      selectedMonthNum < prjStartMonthNum
    )
      return true;
    if (
      selectedYearNum === prjStartYearNum &&
      selectedMonthNum === prjStartMonthNum &&
      calendarDate.getDate() < prjStartMonthDayNum
    )
      return true;

    return false;
  };

  const dayPropGetter = (date) => {
    const dateKey = getDateOnly(date);
    const classes = ["time-log-day-cell"];

    if (loggedHoursByDate[dateKey]) classes.push("time-log-day-cell--logged");
    if (moment(date).isSame(new Date(), "day"))
      classes.push("time-log-day-cell--today");
    if (date.getMonth() + 1 !== parseInt(selectedMonth, 10))
      classes.push("time-log-day-cell--outside");
    if (isBlockedCalendarDate(date)) classes.push("time-log-day-cell--blocked");

    return { className: classes.join(" ") };
  };

  const CalendarEventCard = ({ event, onClick }) => (
    <div
      className="time-log-entry-card"
      onClick={onClick}
      onMouseDown={(event) => event.stopPropagation()}
      onPointerDown={(event) => event.stopPropagation()}
      role="button"
      tabIndex={0}
    >
      <div className="time-log-entry-accent" aria-hidden="true"></div>
      <div className="time-log-entry-body">
        <div className="time-log-entry-status">
          <i className="fa fa-clock-o" aria-hidden="true"></i>
          {event?.title || "0"} Hour(s)
        </div>
      </div>
    </div>
  );

  const CalendarDateHeader = ({ date, label, isOffRange }) => {
    const dateKey = getDateOnly(date);
    const loggedHours = loggedHoursByDate[dateKey];
    const loggedEvent = allEvents.find(
      (event) => getDateOnly(event?.start) === dateKey,
    );
    const isToday = moment(date).isSame(new Date(), "day");
    const isBlocked = isBlockedCalendarDate(date);

    return (
      <div
        className={[
          "time-log-date-header",
          loggedHours ? "time-log-date-header--logged" : "",
          isToday ? "time-log-date-header--today" : "",
          isOffRange ? "time-log-date-header--off-range" : "",
          isBlocked ? "time-log-date-header--blocked" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className="time-log-date-top">
          <span className="time-log-date-number">{label}</span>
        </div>
        {loggedHours && !isOffRange && (
          <CalendarEventCard
            event={{
              title: loggedHours,
              start: date,
            }}
            onClick={(clickEvent) => {
              clickEvent.preventDefault();
              clickEvent.stopPropagation();
              if (isBlocked) return;
              const eventForPopup = {
                ...(loggedEvent || {}),
                start: loggedEvent?.start || date,
                end: loggedEvent?.end || loggedEvent?.start || date,
                title: loggedEvent?.title ?? loggedHours,
              };
              handleWrkHrShowHide(eventForPopup);
            }}
          />
        )}
      </div>
    );
  };

  const eventStyleGetter = (event) => {
    const style = {
      background: "transparent",
      border: "0",
      boxShadow: "none",
      color: "transparent",
      height: 0,
      minHeight: 0,
      opacity: 0,
      padding: 0,
      pointerEvents: "none",
    };
    return {
      style,
    };
  };

  let filterMonths = months.filter((x) => x.id <= new Date().getMonth() + 1);
  if (selectedYear < new Date().getFullYear()) filterMonths = months;

  return (
    <>
      <style>{`
        /* Ensure the modal and backdrop are on top of other elements */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
          overflow-y: hidden !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .wf-timelog-modal.modal-dialog {
          transform: scale(0.96) !important;
          transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .wf-timelog-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .wf-timelog-modal {
          max-width: 1050px !important;
          width: 95% !important;
          font-family: "Open Sans", sans-serif !important;
        }

        .wf-timelog-modal .modal-content {
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
        }

        .wf-timelog-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 14px 24px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }

        .wf-timelog-modal .modal-header::before {
          display: none !important;
        }

        .wf-timelog-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 0 !important;
          width: 100% !important;
        }

        .wf-timelog-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 16px !important;
          width: 100% !important;
        }

        .wf-timelog-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .wf-timelog-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
          min-width: 0 !important;
        }

        .wf-timelog-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 17px !important;
          font-weight: 600 !important;
          line-height: 1.25 !important;
        }

        .wf-timelog-modal .rt-header-icon {
          width: 38px !important;
          height: 38px !important;
          min-height: 38px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 5px rgba(15,23,42,0.06) !important;
          font-size: 16px !important;
          flex-shrink: 0 !important;
        }

        .wf-timelog-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          flex-wrap: wrap !important;
        }

        .wf-timelog-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 3px 8px !important;
          border-radius: 0 !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
        }

        .wf-timelog-modal .rt-modal-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
          font-size: 12px !important;
        }
        .wf-timelog-modal .rt-modal-desc i {
          color: #64748b !important;
        }

        .wf-timelog-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          padding: 0 !important;
          font-size: 14px !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          outline: none !important;
        }
        .wf-timelog-modal .rt-action-btn:hover {
          color: #ef4444 !important;
          border-color: #fca5a5 !important;
          background: #fef2f2 !important;
          transform: translateY(-1px) !important;
        }

        .wf-timelog-modal .modal-body {
          padding: 20px 24px !important;
          background: #ffffff !important;
          max-height: calc(90vh - 140px) !important;
          overflow-y: auto !important;
        }

        /* Controls & Selects */
        .wf-timelog-modal .wf-calendar-top-row {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 16px !important;
          flex-wrap: nowrap !important;
          margin-bottom: 14px !important;
          width: 100% !important;
        }

        .wf-timelog-modal .wf-calendar-heading-wrap {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .wf-timelog-modal .wf-calendar-controls-wrap {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          flex-shrink: 0 !important;
        }

        .wf-timelog-modal select.wf-control-select-compact {
          height: 34px !important;
          padding: 0 26px 0 10px !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #0f172a !important;
          background-color: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          outline: none !important;
          transition: all 0.2s ease !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%2364748b'%3E%3Cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: right 8px center !important;
          background-size: 14px 14px !important;
        }
        .wf-timelog-modal select.wf-control-select-compact:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
        }

        .wf-timelog-modal .wf-hours-card-compact {
          background: #f8fafc !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 0 12px !important;
          height: 34px !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          white-space: nowrap !important;
        }

        .wf-timelog-modal .wf-hours-label {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
        }

        .wf-timelog-modal .wf-hours-value {
          font-size: 13.5px !important;
          font-weight: 700 !important;
          color: #1d4ed8 !important;
        }

        .wf-calendar-badge {
          width: 36px !important;
          height: 36px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          background: #f5f5f5 !important;
          color: #171717 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 1px 2px rgba(15,23,42,0.04) !important;
          font-size: 15px !important;
          flex-shrink: 0 !important;
        }

        .wf-calendar-heading-title {
          font-size: 14px !important;
          font-weight: 700 !important;
          color: #0f172a !important;
          margin-bottom: 1px !important;
        }

        .wf-calendar-heading-text {
          font-size: 12px !important;
          color: #64748b !important;
        }

        .wf-calendar-wrap {
          border-radius: 0 !important;
          border: 1px solid #e2e8f0 !important;
          background: #ffffff !important;
          padding: 16px !important;
          margin-bottom: 16px !important;
        }

        /* Calendar Styles */
        .add-time-log-calendar .rbc-calendar {
          height: auto !important;
          background: transparent !important;
          color: #0f172a !important;
          font-family: inherit !important;
        }
        .add-time-log-calendar .rbc-toolbar {
          margin-bottom: 12px !important;
          gap: 10px !important;
          flex-wrap: wrap !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
        }
        .add-time-log-calendar .rbc-toolbar-label {
          font-size: 16px !important;
          font-weight: 700 !important;
          color: #0f172a !important;
        }
        .add-time-log-calendar .rbc-btn-group {
          display: inline-flex !important;
          gap: 6px !important;
          align-items: center !important;
        }
        .add-time-log-calendar .rbc-btn-group button {
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          background: #ffffff !important;
          color: #334155 !important;
          font-size: 12.5px !important;
          font-weight: 500 !important;
          padding: 6px 12px !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          margin: 0 !important;
          min-width: 60px !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }
        .add-time-log-calendar .rbc-btn-group button.rbc-active,
        .add-time-log-calendar .rbc-btn-group button:hover,
        .add-time-log-calendar .rbc-btn-group button:focus {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
        }
        
        .add-time-log-calendar .rbc-month-view {
          height: auto !important;
          flex: none !important;
          border-radius: 0 !important;
          overflow: hidden !important;
          border: 1px solid #e2e8f0 !important;
          background: #ffffff !important;
        }
        .add-time-log-calendar .rbc-header {
          border-bottom: 1px solid #e2e8f0 !important;
          padding: 8px 6px !important;
          background: #f8fafc !important;
          color: #475569 !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          letter-spacing: 0.05em !important;
          text-transform: uppercase !important;
        }
        .add-time-log-calendar .rbc-month-row + .rbc-month-row {
          border-top: 1px solid #e2e8f0 !important;
        }
        .add-time-log-calendar .rbc-month-row {
          height: 74px !important;
          flex: none !important;
          overflow: visible !important;
        }
        .add-time-log-calendar .rbc-day-bg + .rbc-day-bg,
        .add-time-log-calendar .rbc-header + .rbc-header {
          border-left: 1px solid #e2e8f0 !important;
        }
        .add-time-log-calendar .rbc-day-bg {
          background: transparent !important;
          cursor: pointer !important;
        }
        .add-time-log-calendar .rbc-day-bg::after {
          display: none !important;
        }
        .add-time-log-calendar .rbc-date-cell {
          padding: 3px 4px !important;
          text-align: left !important;
          cursor: pointer !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: stretch !important;
          height: 100% !important;
          overflow: visible !important;
        }
        .add-time-log-calendar .rbc-date-cell > a {
          display: none !important;
        }
        
        .add-time-log-calendar .time-log-date-header {
          height: 66px !important;
          display: flex !important;
          flex-direction: column !important;
          justify-content: space-between !important;
          align-items: stretch !important;
          position: relative !important;
          z-index: 3 !important;
          width: 100% !important;
          border-radius: 0 !important;
          padding: 5px 7px !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          box-shadow: none !important;
          transition: all 0.15s ease !important;
          box-sizing: border-box !important;
        }
        .add-time-log-calendar .time-log-date-header::before {
          display: none !important;
        }
        .add-time-log-calendar .time-log-date-header--logged {
          border-color: #86efac !important;
          border-left: 3px solid #16a34a !important;
          background: #f0fdf4 !important;
        }
        .add-time-log-calendar .time-log-date-header--today {
          border-color: #93c5fd !important;
          border-left: 3px solid #2563eb !important;
          background: #eff6ff !important;
        }
        .add-time-log-calendar .time-log-date-header--today.time-log-date-header--logged {
          border-color: #86efac !important;
          border-left: 3px solid #16a34a !important;
          background: #f0fdf4 !important;
        }
        .add-time-log-calendar .time-log-date-header--blocked,
        .add-time-log-calendar .time-log-date-header--off-range {
          background: #fafafa !important;
          border-color: #e5e5e5 !important;
          border-style: dashed !important;
          opacity: 0.45 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
        }
        .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header {
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
        }
        .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--logged {
          border-color: #16a34a !important;
          background: #dcfce7 !important;
        }
        .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--today {
          border-color: #2563eb !important;
          background: #dbeafe !important;
        }
        .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--blocked,
        .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--off-range {
          background: #fafafa !important;
          border-color: #e5e5e5 !important;
        }

        .add-time-log-calendar .time-log-date-top {
          width: 100% !important;
          display: flex !important;
          justify-content: flex-end !important;
          margin-bottom: 2px !important;
        }
        .add-time-log-calendar .time-log-date-number {
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #475569 !important;
          line-height: 1 !important;
        }
        .add-time-log-calendar .time-log-date-header--logged .time-log-date-number {
          color: #15803d !important;
          font-weight: 700 !important;
        }
        .add-time-log-calendar .time-log-date-header--today .time-log-date-number {
          color: #1d4ed8 !important;
          font-weight: 700 !important;
        }
        .add-time-log-calendar .time-log-date-header--blocked .time-log-date-number,
        .add-time-log-calendar .time-log-date-header--off-range .time-log-date-number {
          color: #cbd5e1 !important;
        }

        .add-time-log-calendar .rbc-off-range-bg {
          background: #fafafa !important;
        }
        .add-time-log-calendar .rbc-today {
          background: transparent !important;
        }
        .add-time-log-calendar .rbc-month-row .rbc-row-content {
          z-index: 2 !important;
          overflow: visible !important;
          height: 100% !important;
        }
        .add-time-log-calendar .rbc-month-row .rbc-row {
          overflow: visible !important;
          height: 100% !important;
        }
        .add-time-log-calendar .rbc-row-segment {
          padding: 0 !important;
        }
        .add-time-log-calendar .rbc-event {
          display: none !important;
        }
        .add-time-log-calendar .rbc-selected {
          background: transparent !important;
        }
        .add-time-log-calendar .rbc-event-content {
          display: none !important;
        }

        .add-time-log-calendar .time-log-entry-card {
          width: 100% !important;
          min-height: 22px !important;
          border-radius: 0 !important;
          background: #ffffff !important;
          border: 1px solid #86efac !important;
          display: flex !important;
          align-items: center !important;
          gap: 4px !important;
          padding: 2px 6px !important;
          overflow: hidden !important;
          cursor: pointer !important;
          margin-top: auto !important;
          box-sizing: border-box !important;
          box-shadow: 0 1px 2px rgba(22, 163, 74, 0.08) !important;
          transition: all 0.15s ease !important;
        }
        .add-time-log-calendar .time-log-entry-card:hover {
          background: #ffffff !important;
          border-color: #16a34a !important;
          box-shadow: 0 2px 4px rgba(22, 163, 74, 0.15) !important;
        }
        .add-time-log-calendar .time-log-entry-accent {
          display: none !important;
        }
        .add-time-log-calendar .time-log-entry-body {
          flex-grow: 1 !important;
          display: flex !important;
          align-items: center !important;
          min-width: 0 !important;
        }
        .add-time-log-calendar .time-log-entry-status {
          color: #15803d !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: flex-start !important;
          gap: 4px !important;
          padding: 0 !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          white-space: nowrap !important;
        }
        .add-time-log-calendar .time-log-entry-status i {
          color: #16a34a !important;
          font-size: 10px !important;
        }

        /* Toggle Card for Non-Billable Staff */
        .wf-timelog-modal .wf-toggle-card {
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 16px 20px !important;
          background: #f8fafc !important;
          margin-top: 16px !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;
        }
        .wf-timelog-modal .wf-toggle-header {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
        }
        .wf-timelog-modal .wf-switch {
          position: relative !important;
          display: inline-flex !important;
          align-items: center !important;
          cursor: pointer !important;
          gap: 10px !important;
          user-select: none !important;
          margin-bottom: 0 !important;
        }
        .wf-timelog-modal .wf-switch input {
          display: none !important;
        }
        .wf-timelog-modal .wf-switch-slider {
          width: 38px !important;
          height: 20px !important;
          background-color: #cbd5e1 !important;
          border-radius: 0 !important;
          position: relative !important;
          transition: background-color 0.2s ease !important;
          flex-shrink: 0 !important;
        }
        .wf-timelog-modal .wf-switch-slider::before {
          content: "" !important;
          position: absolute !important;
          width: 14px !important;
          height: 14px !important;
          border-radius: 0 !important;
          background-color: #ffffff !important;
          top: 3px !important;
          left: 3px !important;
          transition: transform 0.2s ease !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.15) !important;
        }
        .wf-timelog-modal .wf-switch input:checked + .wf-switch-slider {
          background-color: #2563eb !important;
        }
        .wf-timelog-modal .wf-switch input:checked + .wf-switch-slider::before {
          transform: translateX(18px) !important;
        }
        .wf-timelog-modal .wf-switch-label {
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #1e293b !important;
        }

        .wf-timelog-modal .form-group {
          margin-bottom: 0 !important;
        }
        .wf-timelog-modal label.form-control-label {
          display: block !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #334155 !important;
          margin-bottom: 6px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.01em !important;
        }
        .wf-timelog-modal .form-control {
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 8px 12px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #0f172a !important;
          width: 100% !important;
          display: block !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
        }
        .wf-timelog-modal .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
        }

        /* Alert Warning Box */
        .wf-timelog-modal .wf-alert-warning {
          display: flex !important;
          align-items: center !important;
          gap: 10px !important;
          padding: 10px 14px !important;
          border-radius: 0 !important;
          background: #fffbeb !important;
          border: 1px solid #fde68a !important;
          color: #92400e !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
          margin-top: 14px !important;
        }
        .wf-timelog-modal .wf-alert-warning i {
          font-size: 14px !important;
          color: #d97706 !important;
          flex-shrink: 0 !important;
        }

        /* Footer & Modal Action Buttons */
        .wf-timelog-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 14px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 10px !important;
        }

        .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 7px 14px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }
        .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.1) !important;
        }

        .wf-btn-reset-modal {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 6px !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          background: #ffffff !important;
          color: #334155 !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
        }
        .wf-btn-reset-modal:hover {
          background: #eff6ff !important;
          border-color: #93c5fd !important;
          color: #1d4ed8 !important;
        }

        .wf-btn-save {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 7px !important;
          padding: 7px 16px !important;
          border-radius: 0 !important;
          border: 1px solid #2563eb !important;
          background: #2563eb !important;
          color: #ffffff !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }
        .wf-btn-save:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }
        .wf-btn-save:active {
          transform: scale(0.97) !important;
        }
        .wf-btn-save:disabled {
          background: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
          transform: none !important;
        }
`}</style>

      <Modal
        show={tmShowHide}
        size="xl"
        dialogClassName="wf-timelog-modal"
        centered
      >
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i
                  className="rt-header-icon fa fa-calendar-check-o"
                  aria-hidden="true"
                />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>Add Time Log</span>
                      <span className="rt-modal-title-badge">Portal</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">
                    <i className="fa fa-info-circle" aria-hidden="true" /> Log,
                    edit, and review daily working hours.
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handleShowHide("")}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="wf-calendar-top-row">
                <div className="wf-calendar-heading-wrap">
                  <div className="wf-calendar-badge">
                    <i className="fa fa-calendar-o" aria-hidden="true"></i>
                  </div>
                  <div>
                    <div className="wf-calendar-heading-title">
                      Daily Hours Calendar
                    </div>
                    <div className="wf-calendar-heading-text">
                      Pick any valid day in the selected month to log or update working hours.
                    </div>
                  </div>
                </div>
                <div className="wf-calendar-controls-wrap">
                  <select
                    name="year"
                    id="year"
                    className="wf-control-select-compact"
                    onChange={handleYearChange}
                    value={selectedYear}
                    aria-label="Year select"
                    style={{ minWidth: "90px" }}
                  >
                    <option value="">Year</option>
                    {years
                      .filter((x) => x.name <= new Date().getFullYear())
                      .map((y) => (
                        <option key={y.name} value={y.name}>
                          {y.name}
                        </option>
                      ))}
                  </select>

                  <select
                    name="month"
                    id="month"
                    className="wf-control-select-compact"
                    onChange={handleMonthChange}
                    value={selectedMonth}
                    aria-label="Month select"
                    style={{ minWidth: "115px" }}
                  >
                    <option value="">Month</option>
                    {filterMonths.map((m) => (
                      <option key={m.id} value={m.id}>
                        {m.name}
                      </option>
                    ))}
                  </select>

                  <div className="wf-hours-card-compact">
                    <span className="wf-hours-label">
                      Total Hours Logged:
                    </span>
                    <span className="wf-hours-value">
                      {selectedObj?.workingHrs
                        ? getTotalHours(selectedObj.workingHrs)
                        : "0.00"}{" "}
                      hrs
                    </span>
                  </div>
                </div>
              </div>
              <div className="wf-calendar-wrap add-time-log-calendar">
                <Calendar
                  selectable
                  localizer={localizer}
                  events={allEvents}
                  date={selectedDate}
                  views={["month"]}
                  onSelectEvent={handleWrkHrShowHide}
                  onSelectSlot={handleWrkHrShowHide}
                  onNavigate={handleDateChanged}
                  eventPropGetter={eventStyleGetter}
                  dayPropGetter={dayPropGetter}
                  components={{
                    event: CalendarEventCard,
                    month: {
                      dateHeader: CalendarDateHeader,
                    },
                  }}
                />
              </div>
            </div>

                        <div className="col-md-12">
              <div className="wf-toggle-card">
                <div className="wf-toggle-header">
                  <label className="wf-switch" htmlFor="chkMonthlyHrs">
                    <input
                      name="chkMonthlyHrs"
                      id="chkMonthlyHrs"
                      type="checkbox"
                      onChange={handleChkMonthly}
                      value="monHrs"
                      checked={chkMonthlyHrs === "monthly"}
                    />
                    <span className="wf-switch-slider"></span>
                    <span className="wf-switch-label">
                      Check Monthly Hour(s) (For Non-billable staff)
                    </span>
                  </label>
                </div>

                {chkMonthlyHrs === "monthly" && (
                  <div className="row mt-3">
                    <div className="col-md-6 form-group">
                      <label htmlFor="monthlyHrs" className="form-control-label">
                        Enter Monthly Hour(s)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="monthlyHrs"
                        name="monthlyHrs"
                        value={monthlyHrs}
                        placeholder="Enter Monthly Hours"
                        onChange={({ currentTarget }) =>
                          setMonthlyHrs(currentTarget.value)
                        }
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <label htmlFor="monthlyDays" className="form-control-label">
                        Enter Total Day(s)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="monthlyDays"
                        name="monthlyDays"
                        value={monthlyDays}
                        placeholder="Enter Total Days"
                        onChange={({ currentTarget }) =>
                          setMonthlyDays(currentTarget.value)
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

                        <div className="col-md-12">
              <div className="wf-alert-warning">
                <i className="fa fa-exclamation-triangle"></i>
                <div>
                  <strong>Please note:</strong> Documents that are password-protected or restricted from printing should not be uploaded.
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {viewType !== "invoice" ? (
            <>
              <button
                type="button"
                className="wf-modal-footer-close-btn"
                onClick={() => handleShowHide("")}
              >
                <i className="fa fa-times" aria-hidden="true"></i> Close
              </button>
              <button
                type="button"
                className="wf-btn-reset-modal"
                onClick={handleReset}
              >
                <i className="fa fa-refresh" aria-hidden="true"></i> Reset
              </button>

              <button
                type="button"
                className="wf-btn-save"
                onClick={() => doSubmit("save")}
                disabled={saveBtnProccess}
              >
                {saveBtnProccess ? (
                  <>
                    <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>{" "}
                    Saving...
                  </>
                ) : (
                  <>
                    <i className="fa fa-check" aria-hidden="true"></i> Save
                  </>
                )}
              </button>
            </>
          ) : (
            <button
              type="button"
              className="wf-modal-footer-close-btn"
              onClick={() => handleShowHide("")}
            >
              <i className="fa fa-times" aria-hidden="true"></i> Close
            </button>
          )}
        </Modal.Footer>
      </Modal>
      {wrkHrShowHide && (
        <AddWorkingHrs
          handleShowHide={handleWrkHrShowHide}
          showHide={wrkHrShowHide}
          selectedObj={dtObj}
          handleSelect={handleSelect}
          handleeEditSelect={handleeEditSelect}
          allEvents={allEvents}
        ></AddWorkingHrs>
      )}
    </>
  );
};

export default AddNewTimeLog;
